import { dehydrate, QueryClient } from '@tanstack/react-query';
import type { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

import g from 'src/constants/global';
import { CONTACTS_OFFICE, CONTACTS_TOPIC } from 'src/constants/services';
import wrapper from 'src/redux';
import { actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';
import { fetchApiPublishing } from 'src/utils/fetch-api';

const HeadC = dynamic(() => import('src/components/Head'));
const ContactContainer = dynamic(() => import('src/containers/Contact'));

const ContactUs = () => {
	return (
		<>
			<HeadC
				title="Hubungi Kami"
				description={
					'Kamu bisa menghubungi KlikDokter soal peluang karier, mitra dokter, ' +
					'registrasi merchant, hingga support soal keluhan dan iklan di laman berikut.'
				}
			/>

			<ContactContainer />
		</>
	);
};

export const getStaticProps: GetStaticProps = wrapper.getStaticProps((store) => async () => {
	const queryClient = new QueryClient();

	await store.dispatch(actionGetMenu());
	await store.dispatch(actionGetFooterMenu());

	await queryClient.prefetchQuery({
		queryKey: ['contact-us-topic'],
		queryFn: () => fetchApiPublishing({ url: `${CONTACTS_TOPIC.service}` }),
	});

	await queryClient.prefetchQuery({
		queryKey: ['contact-us-office'],
		queryFn: () => fetchApiPublishing({ url: `${CONTACTS_OFFICE.service}` }),
	});

	return {
		props: {
			dehydratedState: dehydrate(queryClient),
			pageHeaderContent: {
				title: 'Hubungi Kami',
				breadcrumbs: [{ label: 'Hubungi Kami' }],
			},
		},
		revalidate: g.REVALIDATE_EXP_ARTICLE,
	};
});

export default ContactUs;
